import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetIsSiteAdmin } from 'domain/usecases/get-is-site-admin';
import { RemoteGetIsSiteAdmin } from 'data/usecases/get-is-site-admin';

export const makeRemoteGetIsSiteAdmin = (): GetIsSiteAdmin => {
  return new RemoteGetIsSiteAdmin(makeApiUrl('/users/is-site-admin'), makeAuthorizeHttpClientDecorator());
};
